export default __webpack_public_path__ + "static/media/2d-image2.dae32a30.png";